module.exports = __webpack_public_path__ + "img/csslogo.edcedd55.png";